import { createTheme as createDSTheme } from 'app/shopify';

export const theme = createDSTheme();
